import type { FeatureManifest } from '@/platform/navigation/featureManifest'

const loadMembershipsFeature = () => import('./entry')

export const membershipPlansManifest: FeatureManifest = {
  id: 'membership-plans',
  path: 'memberships/*',
  navPath: '/memberships',
  label: 'Gói hội viên',
  description: 'Thiết lập gói hội viên',
  load: loadMembershipsFeature,
}
